module.exports = __webpack_public_path__ + "static/media/Sanyog-profile.ed76d71a.png";